import {Trans, useTranslation} from "react-i18next";
import {BigPlayButton, Player} from "video-react";
import Box from "@mui/material/Box";
import Steps from "./steps/Steps";
import {alpha, Grid, Link, Skeleton, Theme, useMediaQuery} from "@mui/material";
import LetsBegin from "./lets_begin/LetsBegin";
import StepsSmall from "./steps/StepsSmall";
import {RootState, useAppDispatch, useAppSelector} from "../../store";
import React, {useEffect, useState} from "react";
import {getHowItWorksContent} from "../../store/how-it-works/ActionCreators";
import PageTitle from "../shared/page-title/PageTitle";
import useHowItWorksJsonLd from "./useHowItWorksJsonLd";
import Typography from "@mui/material/Typography";
import {RoutePaths} from "../../util/constants";
import {Link as RouterLink} from "react-router-dom";
import {useTheme} from "@mui/material/styles";
import CustomTabs from "../shared/custom-tabs/CustomTabs";

const HowItWorks = () => {
    const [type, setType] = useState<"" | "alternative_">("")
    const {t} = useTranslation()
    const matchesSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
    const howItWorksLoading = useAppSelector((state: RootState) => state.howItWorksReducer.loading)
    const howItWorks = useAppSelector((state: RootState) => state.howItWorksReducer.content)
    const dispatch = useAppDispatch()
    const {content} = useHowItWorksJsonLd(howItWorks.steps)
    const theme = useTheme()

    useEffect(() => {
        dispatch(getHowItWorksContent())
    }, [dispatch])

    const typeValue = type === "" ? 0 : 1

    const handleTypeChange = (e: any, type: number) => {
        if (type === 0) setType("")
        else setType("alternative_")
    }

    const tabs = [
        {title: t('vouchers'), component: <></>},
        {title: t('draws'), component: <></>},
    ];

    return (
        <>
            <PageTitle title={t('how_it_works')}/>
            <Box my={5}>
                {howItWorksLoading ? <Skeleton animation="pulse" variant="rectangular" height={350}/> :
                    <Player
                        src={howItWorks.videoUrl}
                        poster={howItWorks.videoThumbnail}
                        preload="metadata"
                        autoPlay={false}
                    >
                        <BigPlayButton position="center"/>
                    </Player>}
            </Box>
            <script
                type="application/ld+json">
                {JSON.stringify(content)}
            </script>
            <CustomTabs color="primary" tabs={tabs} selectedTab={typeValue} handleTabChange={handleTypeChange}
                        sx={{mb: 1}}/>
            {matchesSm ? <StepsSmall steps={howItWorks.steps} loading={howItWorksLoading} type={type}/> :
                <Steps steps={howItWorks.steps} loading={howItWorksLoading} type={type}/>}
            <Grid container justifyContent="center" mt={8}>
                <Typography variant='h6' fontWeight={600} color="primary" maxWidth={600} textAlign='center' sx={{
                    backgroundColor: alpha(theme.palette.primary.main, .1),
                    p: "1em",
                    borderRadius: '0.5em',
                    backdropFilter: 'blur(5px)',
                    fontSize: {xs: '1rem', sm: '1.25rem'}
                }}>
                    <Trans i18nKey="still_not_clear"
                           components={[<Link sx={{cursor: 'pointer'}} component={RouterLink} to={RoutePaths.FAQ}/>,
                               <Link sx={{cursor: 'pointer'}} component={RouterLink} to={RoutePaths.CONTACT}/>]}/>
                </Typography>
            </Grid>

            <LetsBegin/>
        </>
    )
}

export default HowItWorks
